import type { TestShackReportColumnBase } from "@/pages/products/test-shack/models/TestShackReportSectionRev";

/** Layout shared by both mills' report dimension tables. */
const SPEC_ROW = {
	MIN: "min",
	TARGET: "target",
	MAX: "max",
} as const;

type SpecRow = (typeof SPEC_ROW)[keyof typeof SPEC_ROW];

interface SpecRowDefinition {
	id: SpecRow;
	label: string;
	value: (column: TestShackReportColumnBase) => number | null;
	isEmphasized: boolean;
}

export const SPEC_ROWS: readonly SpecRowDefinition[] = [
	{
		id: SPEC_ROW.MIN,
		label: "Min",
		value: (column) => column.ltl,
		isEmphasized: false,
	},
	{
		id: SPEC_ROW.TARGET,
		label: "Target",
		value: (column) => column.nominal,
		isEmphasized: true,
	},
	{
		id: SPEC_ROW.MAX,
		label: "Max",
		value: (column) => column.utl,
		isEmphasized: false,
	},
];

export const stickyLabelCell = {
	backgroundColor: "background.paper",
	left: 0,
	minWidth: 56,
	position: "sticky",
	width: 56,
	zIndex: 1,
} as const;

export const numericCell = {
	fontFamily: "monospace",
	fontSize: "12px",
	fontVariantNumeric: "tabular-nums",
	whiteSpace: "nowrap",
} as const;
